import common from './common'

const geolocation = {

  /**
   * Requisita ao usuário a sua localização
   *
   * @param callback
   */
  getUserLocation: (callback, error) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(callback, error)
    }
  },

  userGeolocation: async () => {
    let cookieCity = null;
    let cookieLocale = null;
    let cookieName = null;
    let cookieUf = null;
    const cookies = document.cookie.split(';');

    for (const element of cookies) {
      const temp = element.trim();
      if (temp.startsWith('__geo_city=')) cookieCity = temp.substring('__geo_city='.length);
      if (temp.startsWith('__geo_locale=')) cookieLocale = temp.substring('__geo_locale='.length);
      if (temp.startsWith('__geo_name=')) cookieName = temp.substring('__geo_name='.length);
      if (temp.startsWith('__geo_uf=')) cookieUf = temp.substring('__geo_uf='.length);
    }

    const isGeolocationGranted = await navigator.permissions.query({ name: "geolocation" })
      .then((result) => result.state === "granted")
      .catch(() => false);

    if (cookieCity && cookieLocale && cookieName && cookieUf && !isGeolocationGranted) {
      const city = cookieCity;
      const locale = cookieLocale;
      const name = cookieName;
      const uf = cookieUf;

      geolocation.renderWeatherNowByGeolocation(locale, city);
      common.dynamicLink(city, name, uf);
      return;
    }

    geolocation.getUserLocation((position) => {
      const url = "/json/minha-localizacao";
      const xhttp = new XMLHttpRequest();

      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          let response;

          try {
            response = JSON.parse(this.response);
          } catch (e) {
            console.error("Resposta inválida do servidor:", this.response);
            fallbackToSaoPaulo();
            return;
          }

          const locationData = response?.data?.[0];
          if (!locationData) {
            console.warn("Dados de localização não encontrados:", response);
            fallbackToSaoPaulo();
            return;
          }

          const { idlocale, idcity, city, uf } = locationData;

          geolocation.renderWeatherNowByGeolocation(idlocale, idcity);
          common.dynamicLink(idcity, city, uf);
        }
      };

      xhttp.open("POST", url, true);
      xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhttp.send(`latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`);
    }, () => {
      fallbackToSaoPaulo();
    });

    function fallbackToSaoPaulo() {
      geolocation.renderWeatherNowByGeolocation(3477, 558);
      common.dynamicLink(558, 'São Paulo', 'SP');
    }
  },

  /**
   * Create component with forecast now for geolocated city
   *
   */
  renderWeatherNowByGeolocation: (idlocale, idcity) => {
    const url = `/json/myclimatempo/user/weatherNow?idlocale=${idlocale}`;
    const xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
      if (this.readyState !== 4 || this.status !== 200) return;

      let response;
      try {
        response = JSON.parse(this.response);
      } catch (e) {
        console.error("Erro ao fazer parse da resposta de weatherNow:", e);
        return;
      }

      const dataPath = response?.data?.getWeatherNow?.[0]?.data?.[0];
      if (!dataPath || !dataPath.locale || !dataPath.weather) {
        console.warn("Dados incompletos para exibir o clima atual:", response);
        return;
      }

      const { locale, weather } = dataPath;
      const slug = common.createSlug(locale.city);
      const acronym = (locale.ac === 'BR') ? locale.uf : locale.ac;
      const cityName = `${locale.city}, ${acronym}`;
      const cityUrl = `${locale.idcity}/${slug}-${acronym.toLowerCase()}`;

      // Salva cookies se estiver na home
      if ($('[data-current-weather]').length > 0) {
        const domain = window.location.hostname;
        document.cookie = `__geo_locale=${idlocale}; domain=.${domain}`;
        document.cookie = `__geo_city=${idcity}; domain=.${domain}`;
        document.cookie = `__geo_name=${locale.name}; domain=.${domain}`;
        document.cookie = `__geo_uf=${locale.uf}; domain=.${domain}`;
      }

      // Exibe o widget geolocalizado
      $('[data-id=geolocated]').removeClass('-hidden-geolocated');
      $('[data-id=geolocated] .city').html(cityName);
      $('[data-id=geolocated] .temperature').html(`${weather.temperature ?? '-'}&deg;`);
      $('[data-id=geolocated] .ico').attr('src', `/dist/images/v2/svg/outline/${weather.icon}.svg`);

      const basePath = window.location.href.includes('agroclima')
        ? `/agroclima/previsao-do-tempo/15-dias/cidade/`
        : `/previsao-do-tempo/cidade/`;

      $('[data-id=geolocated] .link').attr('href', `${basePath}${cityUrl}`);

      // Se tiver bloco completo de clima atual
      if ($('[data-current-weather]').length > 0) {
        const icon = $('<img>', {
          src: `/dist/images/v2/svg/${weather.icon}.svg`,
          alt: `Temperatura agora em ${cityName}`,
          width: 40,
          height: 40
        });

        $('#current-weather-city').html(cityName);
        $('#current-weather-icon').html(icon);
        $('#current-weather-temperature').html(`${weather.temperature ?? '-'}&deg;`);
        $('#current-weather-condition').html(`${weather.condition ?? ''}`);
        $('#current-weather-sensation').html(`${weather.sensation ?? '-'}&deg;`);
        $('#current-weather-humidity').html(`${weather.humidity ?? '-'}%`);
        $('#current-weather-pressure').html(`${weather.pressure ?? '-'} hPa`);
        $('#current-weather-wind').html(`${weather.windVelocity ?? '-'}km/h`);
        $('#current-weather-updated-at').html(`${weather.dateUpdate ?? ''}`);

        $('[data-current-weather] .shimmer-placeholder').removeClass('shimmer-placeholder');
      }

      // Disparo de evento para analytics
      geolocation.errorHitCurrentWeather(weather);
    };

    xhttp.open("POST", url, true);
    xhttp.send();
  },

  errorHitCurrentWeather: (weather) => {
    if (!weather.icon) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_now_icon' });
    }

    if (!weather.temperature) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_now_temperature' });
    }
  }

}

export default geolocation
